// Based on: receipt-frontend-ibow/src/components/dashboard/detail.vue (headerItems)
import { HeaderWidthItem } from "@/types";

//請求一覧（詳細）の項目
export const billingListDetailHeaders: HeaderWidthItem[] = [
  {
    value: "ibow_id",
    text: "利用者ID",
    width: "110px"
  },
  {
    value: "name",
    text: "氏名",
    width: "150px"
  },
  {
    value: "furigana",
    text: "ﾌﾘｶﾞﾅ",
    width: "150px"
  },
  {
    value: "payment_method",
    text: "支払方法",
    width: "100px"
  },
  {
    value: "visit_counts",
    text: "訪問回数",
    width: "100px"
  },
  {
    value: "total",
    text: "合計",
    width: "90px"
  },
  {
    value: "medical_insurance",
    text: "医療/国保連",
    width: "120px"
  },
  {
    value: "medical_paymentfund",
    text: "医療/支払基金",
    width: "140px"
  },
  {
    value: "medical_ownexpense",
    text: "医療/自己負担",
    width: "140px"
  },
  {
    value: "adjust_amount1",
    text: "医療/調整",
    width: "120px"
  },
  {
    value: "care_insurance",
    text: "介護/保険",
    width: "120px"
  },
  {
    value: "care_publicexpenditure",
    text: "介護/公費",
    width: "120px"
  },
  {
    value: "care_ownexpense",
    text: "介護/自己負担",
    width: "140px"
  },
  {
    value: "adjust_amount2",
    text: "介護/調整",
    width: "120px"
  },
  {
    value: "ownexpense",
    text: "自費",
    width: "90px"
  },
  {
    value: "date_of_service",
    text: "サービス提供年月",
    width: "150px"
  },
  {
    value: "medical_printed_at",
    text: "医療処理済年月",
    width: "150px"
  },
  {
    value: "care_printed_at",
    text: "介護処理済年月",
    width: "150px"
  },
  {
    value: "user_invoice_printed_at",
    text: "利用者請求処理済年月",
    width: "170px"
  }
];
